import { cn } from "@/lib/utils";
import { Mix_Content_Category_Enum } from "graphql/generated";
import { ClassAttributes, HTMLAttributes } from "react";

import { ContentAuthorName } from "./ContentAuthorName";
import { ContentCategoryChip } from "./ContentCategoryChip";
import { ContentSourceImg } from "./ContentSourceImg";
import { ContentUpdateTime } from "./ContentUpdateTime";

type ContentSourceAuthorHeaderProps = {
    sourceImgSize: number;
    sourceImgUrl: Mix_ContentFragment["mix_source_info"]["imgurl"];
    authorname: Mix_ContentFragment["authorname"];
    updatetime: Mix_ContentFragment["updatetime"];
    offlinetime: Mix_ContentFragment["offlinetime"];
    category: Mix_ContentFragment["category"];
} & ClassAttributes<HTMLElement> &
    HTMLAttributes<HTMLElement>;

export const ContentSourceAuthorHeader = ({
    sourceImgSize,
    sourceImgUrl,
    authorname,
    updatetime,
    offlinetime,
    category,
    className,
    ...props
}: ContentSourceAuthorHeaderProps) => {
    return (
        <header className={cn("flex items-center gap-2", className)} {...props}>
            {sourceImgUrl && (
                <ContentSourceImg
                    width={sourceImgSize}
                    height={sourceImgSize}
                    imgurl={sourceImgUrl}
                />
            )}
            <div
                className="w-full flex-col md:flex md:flex-row
                    md:justify-between"
            >
                <div className="flex justify-between">
                    <ContentAuthorName>{authorname}</ContentAuthorName>
                    {/* {category && <ContentCategoryChip category={category} />} */}
                </div>
                <ContentUpdateTime
                    updatetime={updatetime}
                    offlinetime={offlinetime}
                    isOffline={category === Mix_Content_Category_Enum.Offline}
                />
            </div>
        </header>
    );
};
